import {put, select, takeLatest} from 'redux-saga/effects';
import {
  GET_SALES_PER_HOUR,
  GET_SALES_PER_HOUR_SUCCESS
} from 'store/analyticsSalesPerHour/action';
import {getAnalyticsV3Api} from 'helpers/services/api/analytics';
import {
  normalizeSalesPerHour,
  unwrapAnalyticsPayload
} from 'helpers/services/api/analyticsHelpers';

function* getSalesPerHour({payload}) {
  try {
    const {locationId} = yield select((state) => state.user);
    const response = yield getAnalyticsV3Api(locationId, {
      startDate: payload.startDate,
      endDate: payload.endDate,
      channelTypes: payload.channelTypes,
      fulfillmentModes: payload.fulfillmentModes,
      includeSalesPerItem: false,
      includeKpi: false,
      includePerHoursStatistics: true
    });
    const normalized = normalizeSalesPerHour(unwrapAnalyticsPayload(response));
    yield put(GET_SALES_PER_HOUR_SUCCESS(normalized));
  } catch (error) {
    yield put(GET_SALES_PER_HOUR_SUCCESS({}));
    console.log('SAGA ERROR', error);
  }
}

function* analyticsSalesPerHourSaga() {
  yield takeLatest(GET_SALES_PER_HOUR, getSalesPerHour);
}

export default analyticsSalesPerHourSaga;
